import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "../../lib/i18n";
import { useAuth } from "../../lib/AuthProvider";

// Toggle segmentado ES | EN. Compacto y theme-aware.
//
// Props:
//  - variant: "light" (fondos claros, ej. login) | "dark" (sidebar oscuro). Default "light".
//  - className: clases extra para el contenedor.
//
// Cambia el idioma en i18next (persiste en localStorage vía detector) y, si hay
// sesión, sincroniza la preferencia con profiles.locale a través de AuthProvider.
const LanguageSwitcher = ({ variant = "light", className = "" }) => {
  const { i18n } = useTranslation();
  const auth = useAuth();
  const current = i18n.resolvedLanguage || i18n.language || "es";

  const handleSelect = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    // Persistir en el perfil si el usuario está logueado (no bloqueante).
    if (auth?.setLocale) auth.setLocale(lng);
  };

  const isDark = variant === "dark";
  const wrap = isDark
    ? "bg-slate-800/60 border-slate-700"
    : "bg-slate-100 border-slate-200";

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-lg border p-0.5 ${wrap} ${className}`}
      role="group"
      aria-label="Language"
    >
      {SUPPORTED_LANGS.map((lng) => {
        const active = current === lng;
        const base = "px-2.5 py-1 text-xs font-semibold rounded-md transition-colors uppercase";
        const activeCls = isDark
          ? "bg-indigo-600 text-white shadow-sm"
          : "bg-white text-indigo-700 shadow-sm";
        const idleCls = isDark
          ? "text-slate-400 hover:text-slate-200"
          : "text-slate-500 hover:text-slate-800";
        return (
          <button
            key={lng}
            type="button"
            onClick={() => handleSelect(lng)}
            aria-pressed={active}
            className={`${base} ${active ? activeCls : idleCls}`}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
